export const fontScalings = [200, 170, 135, 120, 110, 100, 95, 90, 85];
